import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { object } from "prop-types";

import "./reference-element.m.css";

const ReferenceElement = ({ element }) => {
  const metadata = get(element, ["metadata"], {});
  const { name = "", description = "", url = "" } = metadata;

  return (
    <div styleName="wrapper">
      <Link href={url} target="_blank" rel="noopener noreferrer" aria-label="name">
        <div styleName="name">{name}</div>
      </Link>
      <div styleName="description">{description}</div>
    </div>
  );
};

ReferenceElement.propTypes = {
  element: object,
};

export default ReferenceElement;
